<app-window-title [closable]="true" [title]="'User Profile'" (closed)="dialogRef.close()"></app-window-title>
<div fxLayout="column" class="dialog-content" fxLayoutAlign="center center">
  <!-- <form
    *ngIf="clientForm"
    [formGroup]="clientForm"
    class="full-width"
    (ngSubmit)="onSubmit()"
  >
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Name</mat-label>
      <input formControlName="name" required matInput />
      <mat-error *ngIf="clientForm.controls['name'].invalid">{{
        getErrorMessage(clientForm.controls["name"], "name")
      }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Email</mat-label>
      <input formControlName="email" type="email" matInput />
      <mat-error *ngIf="clientForm.controls['email'].invalid">{{
        getErrorMessage(clientForm.controls["email"], "email")
      }}</mat-error>
    </mat-form-field>
    <br />
    <section>
      <button mat-raised-button type="submit" color="warn">
        UPDATE USER INFORMATION
      </button>
    </section>
  </form> -->
  <section class="full-width">
    <h4>
      Session settings
    </h4>
    <i>
      The sessions will timeout after 30 min. of idle time
    </i>
    <br>
    <br>
    <mat-slide-toggle checked="{{ sessionTimeOutState === true }}" color="warn" (change)="handleChange($event)">
      Session TimeOut
    </mat-slide-toggle>
  </section>
 <!-- FIXME: Investigate what is this for -->
  <!-- <section *ngIf="userIsOwner" class="full-width">
    <h4>
      Owner Settings
    </h4>
    <mat-slide-toggle checked="{{ showConsultantsFolders === true }}" color="warn"
      (change)="handleShowConsultantsFoldersChange($event)">
      Show Client Profile Consultants folders.
    </mat-slide-toggle>
  </section> -->
  <section *ngIf="quotaOwnerID" class="full-width">
    <h4>Image Transfers</h4>
    <app-cmove-quota-bar [ownerID]="quotaOwnerID"></app-cmove-quota-bar>
    <a class="usage-link" (click)="navigateToUsage()">View full usage dashboard →</a>
  </section>
  <section class="full-width">
    <h4>Appearance</h4>
    <mat-button-toggle-group
      [value]="theme_$.mode"
      (change)="handleThemeChange($event)"
      aria-label="App theme"
      class="theme-toggle-group">
      <mat-button-toggle value="light">
        <mat-icon>light_mode</mat-icon>
        Light
      </mat-button-toggle>
      <mat-button-toggle value="dark">
        <mat-icon>dark_mode</mat-icon>
        Dark
      </mat-button-toggle>
      <mat-button-toggle value="device">
        <mat-icon>devices</mat-icon>
        Device
      </mat-button-toggle>
    </mat-button-toggle-group>
  </section>
  <section class="full-width">
    <h4>Security</h4>
    <button mat-stroked-button color="warn" (click)="handleChangePassword()">
      Change Password
    </button>
  </section>
</div>